import React, { FC } from "react";

import { ActionableMessage, ActionableMessageProps, Icon } from "../../common";
import { UIStatus } from "../../../types/GlobalTypes";

export const AdditionalVerificationMessage: FC<
  Omit<ActionableMessageProps, "heading" | "text" | "type" | "icon">
> = (props) => {
  return (
    <ActionableMessage
      heading="Verification in progress..."
      text="Your verification is underway. We’ll notify you once it's done. If you need immediate assistance, please contact us"
      type={UIStatus.ERROR}
      ctaProps={{
        className: "contact-support-btn",
      }}
      ctaContent={
        <div className="w-full flex justify-between">
          Get Help{" "}
          <Icon
            icon="support_agent"
            size={24}
            className="text-white"
            disableFill
          />
        </div>
      }
      {...props}
    />
  );
};
